import {
  Beacon,
  BeaconBase,
  MarkerColor,
  Position,
  Project,
  SiteWithBeacons,
} from "../../api/models";
import { MarkerData, PolyLineData, PolygonData } from "./Map";

export const getPolygonsSites = <T>(
  sites: SiteWithBeacons[],
  color: string,
  onClickEvent: (node: T) => void
): PolygonData[] => {
  try {
    return sites
      .filter((coord) => coord.area !== null)
      .map((coord) => ({
        color: color,
        ring: coord.area!,
        title: coord.name,
        id: coord.id,
        onClick: () => onClickEvent({ selectedId: coord.id } as unknown as T),
      }));
  } catch (error) {
    console.log("Error in getPolygonsSites", error);
    return [];
  }
};

export const getPolygonsProjects = <T>(
  projects: Project[],
  color: string,
  onClickEvent: (node: T) => void
): PolygonData[] => {
  try {
    return projects
      .filter((coord) => coord.area !== null)
      .map((coord) => ({
        color: color,
        ring: coord.area!,
        title: coord.name,
        id: coord.id,
        onClick: () => onClickEvent({ selectedId: coord.id } as unknown as T),
      }));
  } catch (error) {
    console.log("Error in getPolygonsProjects", error);
    return [];
  }
};

// No API as of Feb 25 to get this data, so handling it in client side
export const getPolylinesSites = <T>(
  sites: SiteWithBeacons[] | undefined,
  color: string,
  width: number,
  onClickEvent: (node: T) => void
): PolyLineData[] => {
  if (!sites) return [];

  try {
    return sites
      ?.filter((site) => site.totalBeacons == 2)
      .map((site) => ({
        line: site.beacons.map((beacon) => {
          return { lat: beacon.position.lat, lon: beacon.position.lon };
        }),
        title: site.name,
        id: site.id,
        color: color,
        width: width,
        onClick: () => onClickEvent({ selectedId: site.id } as unknown as T),
      }));
  } catch (error) {
    console.log("Error in getPolylinesSites", error);
    return [];
  }
};

export const transformBeaconsToMarkers = <T>(
  beacons: BeaconBase[] | undefined,
  onClickEvent: (node: T) => void
): MarkerData[] => {
  if (beacons === undefined) return [];

  try {
    const filteredBeacons = beacons.filter(
      (beacon: BeaconBase) => beacon.isOn === true
    );

    const markers: MarkerData[] = filteredBeacons
      .map((beacon) => {
        if (beacon.position === null) return undefined;
        return {
          title: beacon.serial,
          lat: beacon.position.lat,
          lon: beacon.position.lon,
          color: getMarkerColorBeacon(beacon),
          onClick: () =>
            onClickEvent({
              selectedId: beacon.serial,
              selectedType: "marker",
            } as unknown as T),
        };
      })
      .filter((marker) => marker !== undefined) as MarkerData[];

    return markers;
  } catch (error) {
    console.log("Error in transformBeaconsToMarkers", error);
    return [];
  }
};

export const getMarkerColorBeacon = (
  beacon: Beacon | BeaconBase
): MarkerColor => {
  if (beacon.isOn === false) {
    return "gray";
  }

  return beacon.position?.cprs === 2 ? "green" : "orange";
};

export const getMarkerColorSCBOne = (runPosition: Position): MarkerColor => {
  return runPosition?.cprs === 2 ? "green" : "orange";
};
